import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType } from '../../../../packages/JsonQuery';
import { selectKidsAllowed, selectPetsAllowed } from 'shared/selectors/jsonQuery';

export const selectLivingConditionsValue = createSelector(
  [selectKidsAllowed, selectPetsAllowed],
  (kidsAllowed, petsAllowed) => {
    const livingConditions: EFacilityType[] = [];

    if (kidsAllowed) {
      livingConditions.push(EFacilityType.KidsAllowed);
    }

    if (petsAllowed) {
      livingConditions.push(EFacilityType.PetsAllowed);
    }

    return livingConditions.length > 0 ? livingConditions : [null];
  },
);
